module.exports = __webpack_public_path__ + "img/eight.af90fc6d.png";